import { Card, Stack } from "@mui/material";
import { useContext } from "react";
import useLocales from "src/hooks/useLocales";

import Context from "../context";
import useGetAppConfig from "../services/useGetAppConfig";
import useGetAppEntitiesList from "../services/useGetAppEntitiesList";
import CardHeader from "./components/CardHeader";
import ConfigItem from "./components/ConfigItem";
import FooterBtn from "./components/FooterBtn";
import SkeletonPanel from "./components/SkeletonPanel";

// ----------------------------------------------------------------------

export const PolicyConfigCard = () => {
	const { state } = useContext(Context);

	const { isLoading } = useGetAppConfig();
	useGetAppEntitiesList();

	const { translate } = useLocales();

	return (
		<Card sx={{ p: 3, maxWidth: 800 }}>
			<CardHeader />
			{isLoading && <SkeletonPanel />}
			{!isLoading && (
				<Stack gap={2} sx={{ mt: 2 }}>
					<ConfigItem
						id={"TEST"}
						title={translate("app_config.all_banks")}
						isSelected={state.selectedConfig === "TEST"}
						description={translate("app_config.all_bancs_des")}
					/>
					<ConfigItem
						id={"PRODUCTION"}
						title={translate("app_config.recommend_banks")}
						isSelected={state.selectedConfig === "PRODUCTION"}
						description={translate("app_config.recommend_banks_des")}
					/>
					<ConfigItem
						id={"CUSTOM"}
						isSelected={state.selectedConfig === "CUSTOM"}
						title={translate("app_config.custom_list")}
						description={translate("app_config.custom_list_des")}
					/>
				</Stack>
			)}
			{!isLoading && <FooterBtn />}
		</Card>
	);
};

export default PolicyConfigCard;
